<template>
  <div class="container">
    <van-search
      v-model="keyword"
      placeholder="请输入门店名称或POIID"
      shape="round"
      clearable
      @search="search"
    >
      <template #left-icon>
        <img
          class="search-icon"
          src="@/assets/img/search@2x.png"
          alt=""
        />
      </template>
      <template #right-icon>
        <div
          class="search-btn"
          @click="search"
        >
          搜索
        </div>
      </template>
    </van-search>
    <div class="filter-container">
      <div
        v-for="tagKey in Object.keys(serviceGrades.tagKeyMap)"
        :key="tagKey"
        class="filter-btn"
        :class="{ 'active-btn': serviceGrades.tagKeyList.includes(tagKey) }"
        @click="clickServiceGrades(tagKey)"
      >
        {{ serviceGrades.tagKeyMap[tagKey] }}
      </div>
      <div
        v-for="tagKey in Object.keys(indicatorCodes.tagKeyMap)"
        :key="tagKey"
        class="filter-btn"
        :class="{ 'active-btn': indicatorCodes.tagKeyList.includes(tagKey) }"
        @click="clickIndicatorCodes(tagKey)"
      >
        {{ indicatorCodes.tagKeyMap[tagKey] }}
      </div>
    </div>
    <div class="poi-card-container">
      <div
        v-if="loading"
        class="loading-card"
      >
        <img src="@/assets/img/icon_rotation_animation@3x.png" />
        <div class="loading-card__text">
          加载中...
        </div>
      </div>
      <div v-else>
        <div
          v-if="poiList.length === 0"
          class="empty-card"
        >
          无搜索结果
        </div>
        <PoiCard
          v-for="item in poiList"
          :key="item.poiId"
          :item="item"
        />
        <div
          v-if="hasMoreData && isLoadingNextPage"
          class="footer"
        >
          加载中...
        </div>
        <div
          v-if="!isLoadingNextPage && !hasMoreData && poiList.length !== 0"
          class="footer"
        >
          没有更多了～
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PoiCard from './components/PoiCard';
import ServiceLevelApi from '@/api/serviceLevel';
import { INDICATOR_CUST_COMPLAINT_CODES_MAP, SERVICE_LEVEL_NUMBER_CODES_MAP } from '@/constants/serviceLevel';
import Store from '@/store/index';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';

export default {
  name: 'ServiceLevelPoiListSearch',
  components: {
    PoiCard,
  },
  data() {
    return {
      keyword: '',
      loading: false,
      poiList: [],
      pageParams: {
        pageSize: 10,
        pageNum: 1,
      },
      serviceGrades: {
        tagKeyMap: SERVICE_LEVEL_NUMBER_CODES_MAP,
        tagKeyList: [],
      },
      indicatorCodes: {
        tagKeyMap: INDICATOR_CUST_COMPLAINT_CODES_MAP,
        tagKeyList: [],
      },
      isLoadingNextPage: false,
      hasMoreData: true,
      partnerId: Store.getters['partnerModule/id'],
      cid: this.$CID.ServiceLevelPoiList,
    };
  },
  async mounted() {
    this.initFilter();
    window.addEventListener('scroll', this.handleScroll);
    await this.onSearch();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    search() {
      tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_SEARCH_SEARCH, null, { cid: this.cid });
      this.onSearch();
    },
    async onSearch() {
      this.pageParams.pageNum = 1;
      this.poiList = [];
      this.hasMoreData = true;
      this.loading = true;
      await this.getPoiList();
      this.loading = false;
    },
    async getPoiList() {
      const params = {
        ...this.pageParams,
        partnerId: this.partnerId,
        indicatorCodes: this.indicatorCodes.tagKeyList,
        lastmonthServiceGrades: this.serviceGrades.tagKeyList,
        keyword: this.keyword,
      };
      const { data, error } = await ServiceLevelApi.getPoiList(params);
      if (!error && data) {
        const list = data.list.map((item) => ({
          ...item,
          serviceGrade: !item.lastmonthServiceGrade ? -1 : item.lastmonthServiceGrade,
          bizareaRank: !item.lastmontBizareaRank ? -1 : item.lastmonthBizareaRank,
          bizareaRankRatio: !item.lastmonthBizareaRankRatio ? '' : item.lastmonthBizareaRankRatio,
        }));
        if (data.total <= this.pageParams.pageSize * (this.pageParams.pageNum - 1) + data.list.length) {
          this.hasMoreData = false;
        }
        this.poiList.push(...list);
      }
    },
    async clickServiceGrades(tagKey) {
      const tagKeyList = this.serviceGrades.tagKeyList;
      const index = tagKeyList.indexOf(tagKey);
      if (index !== -1) {
        tagKeyList.splice(index, 1);
      } else {
        tagKeyList.push(tagKey);
      }
      await this.onSearch();
      tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_SEARCH_FILTER, null, { cid: this.cid });
    },
    async clickIndicatorCodes(tagKey) {
      const tagKeyList = this.indicatorCodes.tagKeyList;
      const index = tagKeyList.indexOf(tagKey);
      if (index !== -1) {
        tagKeyList.splice(index, 1);
      } else {
        tagKeyList.push(tagKey);
      }
      await this.onSearch();
      tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_SEARCH_FILTER, null, { cid: this.cid });
    },
    initFilter() {
      const { serviceGradeFilter, indicatorCodeFilter } = this.$route.query;
      this.serviceGrades.tagKeyList = serviceGradeFilter || [];
      this.indicatorCodes.tagKeyList = indicatorCodeFilter || [];
    },
    handleScroll() {
      // 检测是否滚动到底部
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 50) {
        // 距离底部 50px 时触发加载下一页
        this.loadNextPage();
      }
    },
    async loadNextPage() {
      if (this.isLoadingNextPage || !this.hasMoreData) {
        return; // 如果正在加载或没有更多数据，则不执行
      }
      this.pageParams.pageNum = this.pageParams.pageNum + 1;
      this.isLoadingNextPage = true;
      await this.getPoiList();
      this.isLoadingNextPage = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  min-height:100vh;
  color: #222;
  .van-search {
    padding: 0.1rem 0.24rem 0.24rem 0.24rem;
    font-size: 0.28rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2025;
    width: 100%;
    &__content {
      width: 6.22rem;
      height: 0.68rem;
      border-radius: 10rem;
      padding: 0 0 0 0.24rem;
      background-color: #f5f5f5;
      color: #888;
      display: flex;
      align-items: center;
      .search-icon {
        width: 0.26rem;
        margin-top: 0.16rem;
      }
      .search-btn {
        background: linear-gradient(118deg, #FFE74D 0%, #FFDD00 100%);
        padding: 0.08rem 0.24rem;
        margin-right: -0.1rem;
        color:#111;
        border-radius: 10rem;
        font-weight: 600;
        height: 0.56rem;
        display: flex;
        align-items: center;
      }
      .van-field__control {
        font-size: 0.28rem;
        font-family: "PingFang SC";
      }
    }
  }
  .filter-container {
    display: flex;
    padding: 1.26rem 0 0 0.24rem;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none; /* 隐藏滚动条 (适用于 Firefox) */
    -ms-overflow-style: none; /* 隐藏滚动条 (适用于 IE 和 Edge) */
    &::-webkit-scrollbar {
      display: none; /* 隐藏滚动条 (适用于 Webkit 浏览器) */
    }
    .filter-btn {
      padding: 0.16rem 0.24rem;
      border-radius: 0.09rem;
      line-height: 0.24rem;
      margin-right: 0.12rem;
      font-size: 0.24rem;
      background: #FFF;
      border: 2px solid #E5E5E5;
    }
    .active-btn {
      background: #FFF9DE;
      border: 2px solid #FFD100;
    }
  }
  .poi-card-container {
    color: #222;
    font-family: "PingFang SC";
    padding: 0 0.24rem;
    position: relative;
    text-align:left;
    .loading-card {
      position: absolute;
      left: 3.39rem;
      top: 30vh;
      img {
        width: 0.72rem;
        display: block;
        margin: 0 auto;
      }
      &__text {
        font-size: 0.28rem;
        margin-top: 0.18rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .empty-card {
      position: absolute;
      left: 2.95rem;
      top: 4.755rem;
      font-size: 0.32rem;
      font-weight: 600;
      margin-top: 0.36rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .footer {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666;
      font-size: 0.24rem;
      padding: 0.3rem 0;
    }
  }
}
</style>
